export default ({ request }) => ({
  opaScmDetailApi(data) {
    return request({
      url: '/digitalCenter/opa/scm/detail',
      method: 'post',
      data
    })
  },
  opaScmOaViewDetailApi(data) {
    return request({
      url: '/digitalCenter/opa/scm/oaViewdetail',
      method: 'post',
      data
    })
  },
  opaScmContactsListApi(data) {
    return request({
      url: '/digitalCenter/opa/scm/contacts/list',
      method: 'post',
      data
    })
  },
  opaScmImageListApi(data) {
    return request({
      url: '/digitalCenter/opa/scm/image/list',
      method: 'post',
      data
    })
  },
  opaScmImageListPageApi(data) {
    return request({
      url: '/digitalCenter/opa/scm/image/listPage',
      method: 'post',
      data
    })
  },
  opaScmVisitDetailApi(data) {
    return request({
      url: '/digitalCenter/opa/scm/visit/detail',
      method: 'post',
      data
    })
  },
  opaScmVisitListTimeLineApi(data) {
    return request({
      url: '/digitalCenter/opa/scm/visit/listTimeLine',
      method: 'post',
      data
    })
  },
  opaScmScoreGetScoreListApi(data) {
    return request({
      url: '/digitalCenter/opa/scm/score/getScoreList',
      method: 'post',
      data
    })
  },
  opaScmVisitscoreGetVisitScoreApi(data) {
    return request({
      url: '/digitalCenter/opa/scm/visitscore/getVisitScore',
      method: 'post',
      data
    })
  },
  opaScmVisitscoreGetVisitScoreListApi(data) {
    return request({
      url: '/digitalCenter/opa/scm/visitscore/getVisitScoreList',
      method: 'post',
      data
    })
  },
  opaCustomerDetailApi(data) {
    return request({
      url: '/digitalCenter/opa/customer/detail',
      method: 'post',
      data
    })
  },
  //客户档案选项信息列表查询接口
  opaCustomerLablesListApi(data) {
    return request({
      url: '/digitalCenter/opa/customer/labels/list',
      method: 'post',
      data
    })
  },
  opaFabricStockOutDetailApi(data) {
    return request({
      url: '/digitalCenter/opa/fabric/stockOut/detail',
      method: 'post',
      data
    })
  },
  opaUserTripRequestDetailApi(data) {
    return request({
      url: '/digitalCenter/opa/usertrip/request/detail',
      method: 'post',
      data
    })
  },
  opaUserTripReimbursementDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/opa/user/trip/reimbursement/detail',
      method: 'POST',
      data,
    })
  },
  opaUserTripReimbursementReportListApi(data = {}) {
    return request({
      url: '/digitalCenter/opa/user/trip/reimbursement/report/list',
      method: 'POST',
      data,
    })
  },
  opaUserTripReimbursementReportDocListApi(data = {}) {
    return request({
      url: '/digitalCenter/opa/user/trip/reimbursement/report/doc/list',
      method: 'POST',
      data,
    })
  },
  opaUserPaymentRequestApi(code) {
    return request({
      url: '/digitalCenter/opa/user/payment/request/getByCode',
      method: 'GET',
      params: { code },
    })
  },
  opaUserReimbursementApi(code) {
    return request({
      url: '/digitalCenter/opa/user/reimbursement/getByCode',
      method: 'GET',
      params: { code },
    })
  },
  opaFabricExpenseApi(code) {
    return request({
      url: '/digitalCenter/opa/fabric/expense/getByCode',
      method: 'GET',
      params: { code },
    })
  },
  opaUserLoanRequestApi(code) {
    return request({
      url: '/digitalCenter/opa/user/loan/request/getByCode',
      method: 'GET',
      params: { code },
    })
  },
  opaUserContactFormApi(code) {
    return request({
      url: '/digitalCenter/opa/user/contact/form/getByCode',
      method: 'GET',
      params: { code },
    })
  },
  opaUserMaterialAbnormalApi(code) {
    return request({
      url: '/digitalCenter/opa/user/material/abnormal/getByCode',
      method: 'GET',
      params: { code },
    })
  },
})
